<div class="input-grid-gaps grid-1col">
    <app-select-input
        [form]="form"
        id="userId"
        label="person.dashboard.palliativeCare.fields.user"
        filterBy="name,email,surname"
        [infiniteScroll]="userScroll()"
        valueKey="id"
    >
        <ng-template #item let-item>
            {{ item | formatPerson }}
        </ng-template>
        <ng-template #selectedItem let-item>
            {{ item | formatPerson }}
        </ng-template>
    </app-select-input>

    <app-date-input [form]="form" id="dateFrom"
        label="person.dashboard.palliativeCare.fields.dateFrom"
    ></app-date-input>
    <app-date-input [form]="form" id="dateTo"
        label="person.dashboard.palliativeCare.fields.dateTo"
    ></app-date-input>
    <app-text-input [form]="form" id="note"></app-text-input>
</div>
